<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sortType" placeholder="请选择" size="small">
                        <el-option label="按热度从高至低排序" :value="0"></el-option>
                        <el-option label="按热度从低至高排序 " :value="1"></el-option>
                        <el-option label="按时间从新至旧排序" :value="2"></el-option>
                        <el-option label="按点赞数从多到少排序" :value="3"></el-option>
                        <el-option label="按评论数从多到少排序" :value="4"></el-option>
                        <el-option label="按转发数从多至少排序" :value="5"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.category" placeholder="请选择" size="small">
                        <el-option label="不限制动态类型" value=""></el-option>
                        <el-option label="仅看现场的 " :value="1"></el-option>
                        <el-option label="仅看瞬间的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="发布人ID" :value="1"></el-option>
                            <el-option label="关联演出ID" :value="2"></el-option>
                            <el-option label="动态ID" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>

                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.articleType" placeholder="请选择" size="small">
                        <el-option label="不限制内容类型" value=""></el-option>
                        <!-- <el-option label="仅看文字的 " :value="1"></el-option> -->
                        <el-option label="仅看图文的" :value="2"></el-option>
                        <el-option label="仅看视频的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.type" placeholder="请选择" size="small">
                        <el-option label="不限制状态" :value="0"></el-option>
                        <el-option label="仅看正常的" :value="1"></el-option>
                        <el-option label="仅看屏蔽的" :value="2"></el-option>
                        <el-option label="仅看被举报的" :value="3"></el-option>
                        <el-option label="仅看被用户删除的" :value="-1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.source" placeholder="请选择" size="small">
                        <el-option label="不限制帖子来源" value=""></el-option>
                        <el-option label="仅看用户发布的" :value="0"></el-option>
                        <el-option label="仅看管理后台发布的" :value="1"></el-option>
                        <el-option label="仅看B端视频转帖子的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isTop" placeholder="请选择" size="small">
                        <el-option label="不限制置顶状态" value=""></el-option>
                        <el-option label="仅查看已置顶的" :value="1"></el-option>
                        <el-option label="仅查看未置顶的" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.cityName" placeholder="请输入城市名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.topicName" placeholder="请输入话题名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="发布时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            align="right"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/article/new')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="$router.push('/dynamic/article/add')">发布动态</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="动态ID">
                </el-table-column>
                <el-table-column prop="type" label="内容类型">
                    <template slot-scope="scope">
                        {{type.get(scope.row.type)}}
                    </template>
                </el-table-column>
                <el-table-column label="内容" show-overflow-tooltip min-width="150">
                    <template slot-scope="scope">
                        <template v-if="scope.row.mood || scope.row.moodTitle">
                            【
                                <el-image v-if="scope.row.mood" :src="scope.row.mood" fit="contain" style="width:18px"></el-image>
                                <template v-else></template>
                                {{scope.row.moodTitle}}
                            】
                        </template>
                        <template v-else></template>
                        {{scope.row.content}}
                    </template>
                </el-table-column>
                <el-table-column label="图片/视频">
                    <template slot-scope="scope">
                        <template v-if="scope.row.photoList && scope.row.type != 3">
                            <el-image v-if="scope.row.photoList.length == 1" :src="scope.row.photoList[0] | coverImage(120,120)" fit="cover" :preview-src-list="[scope.row.photoList[0]]"></el-image>
                            <el-button v-else-if="scope.row.photoList.length > 1" type="text" size="mini" @click="previewImg(scope.row.photoList)">多图</el-button>
                        </template>
                        <template v-else-if="scope.row.mediaUrlList && scope.row.type == 3">
                            <div v-if="scope.row.mediaUrlList.length == 1" class="video-cover" @click="playVideo(scope.row.mediaUrlList[0])">
                                <el-image :src="scope.row.photoList[0] | coverImage(120,120)" fit="cover"></el-image>
                                <span class="el-icon-video-play"></span>
                            </div>
                            <el-button v-else-if="scope.row.mediaUrlList.length > 1" type="text" size="mini" @click="previewVideo(scope.row.photoList,scope.row.mediaUrlList)">查看视频</el-button>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="ownerId" label="发布人ID">
                </el-table-column>
                <el-table-column prop="reviewCount" label="评论数">
                </el-table-column>
                <el-table-column prop="dingCount" label="点赞数">
                </el-table-column>
                <el-table-column prop="declareNum" label="表态数">
                </el-table-column>
                <el-table-column prop="shareCount" label="转发数">
                </el-table-column>
                <el-table-column prop="hot" label="热度">
                </el-table-column>
                <el-table-column prop="createTime" label="发布时间" min-width="150">
                </el-table-column>
                <el-table-column prop="activityId" label="关联演出ID" min-width="90">
                </el-table-column>
                <el-table-column prop="isReport" label="是否被举报" min-width="90">
                    <template slot-scope="scope">
                        <span :class="{'color-danger': scope.row.isReport == 1}">{{scope.row.isReport == 1 ? "是" : "否"}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <span :class="{'color-success': scope.row.status == 2}">{{status.get(scope.row.status)}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <template v-if="$utils.have('/article/updateStatus')">
                            <el-button
                                v-if="scope.row.status == 0"
                                type="text"
                                size="small"
                                @click="editStatus(scope.row.id,2)"
                                >开放</el-button
                            >
                            <el-button
                                v-else-if="scope.row.status == 2"
                                type="text"
                                size="small"
                                @click="editStatus(scope.row.id,0)"
                                >屏蔽</el-button
                            >
                        </template>
                        <el-button
                            v-if="$utils.have('/article/updateHot')"
                            type="text"
                            size="small"
                            @click="editHot(scope.row)"
                            >热度</el-button
                        >

                        <el-button
                            v-if="$utils.have('/article/info')"
                            type="text"
                            size="small"
                            @click="review(scope.row)"
                            >评论</el-button
                        >

                        <el-button
                            v-if="$utils.have('/article/createMount') && scope.row.source == 2"
                            type="text"
                            size="small"
                            @click="$refs.videoMount.show(scope.row)"
                            >挂载</el-button>
                        
                        <el-button
                            v-if="$utils.have('/article/top')"
                            type="text"
                            size="small"
                            @click="setTop(scope.row)"
                            >{{ scope.row.isTop == 1 ? '取消置顶' : '置顶' }}</el-button>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <el-dialog :visible.sync="photoListView" title="动态图片" center append-to-body>
            <div class="preview-box">
                <el-image style="width: 100px; height: 100px;margin: 10px;" v-for="(image, index) in photoList" fit="cover" :src="image | coverImage(200,200)" :preview-src-list="photoList.slice(index).concat(photoList.slice(0,index))" :key="index">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="vListView" title="动态视频" center append-to-body>
            <div class="preview-box">
                <div class="video-cover" v-for="(image, index) in vPhotoList" :key="index" @click="playVideo(vList[index])">
                    <el-image style="width: 200px; height: 150px;"  fit="cover" :src="image | coverImage(400,300)">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <span class="el-icon-video-play"></span>
                </div>
            </div>
        </el-dialog>
        <VideoPlay ref="videoPlay"></VideoPlay>
        <EditHot ref="editHot" @onUpdate="getDataList"></EditHot>
        <video-mount ref="videoMount" @onUpdate="getDataList"></video-mount>
    </div>
</template>
<script>
import VideoPlay from "@/components/VideoPlay";
import EditHot from "./components/EditHot.vue";
import VideoMount from "./components/VideoMount.vue";
const defaultParams = {
    pageNo:1,
    cityName:"",
    topicName: "",
    type: 0,
    startTime:'',
    endTime:'',
    timeType: 1,
    sortType: 0,
    category: "",
    articleType: "",
    searchType: 1,
    searchValue: "",
    source: "",
    isTop: ""
}
export default {
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                type: parseInt(this.$route.query.type || 0),
                startTime: this.$route.query.startTime || '',
                endTime: this.$route.query.endTime || '',
                timeType: parseInt(this.$route.query.timeType || 1),
                sortType: parseInt(this.$route.query.sortType || 0),
                category: this.$route.query.category || '',
                articleType: this.$route.query.articleType || '',
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                source: parseInt(this.$route.query.source) || '',
                isTop: parseInt(this.$route.query.isTop) || "",
            },
            listLoading: true,
            datetimerange: [this.$route.query.startTime || '' , this.$route.query.endTime || ''],
            photoList: [],
            photoListView: false,
            vPhotoList: [],
            vList:[],
            vListView: false
        }
    },
    components:{VideoPlay,EditHot,VideoMount},
    computed: {
        type(){
            return new Map([
                [1,'文字动态'],[2,'图文动态'],[3,'视频动态'],[4,'语音动态']
            ])
        },
        status(){
            return new Map([
                [-1,'删除'],[0,'屏蔽'],[2,'正常']
            ])
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.listLoading = true;
            this.$request({
                url: "/article/pageList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //预览图片
        previewImg(list){
            this.photoList = list;
            this.photoListView = true;
        },
        // 播放视频
        playVideo(url){
            this.$refs.videoPlay.show({url:url});
        },
        //更多视频
        previewVideo(img,video){
            this.vPhotoList = img;
            this.vList = video;
            this.vListView =  true;
        },
        //编辑状态
        editStatus(id,status){
            const _msg = status == 2 ? '确定要开放吗?' : '确定要屏蔽吗？';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/article/updateStatus',
                    method: 'POST',
                    params: {id:id,status:status}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        let timer = setTimeout(() => {
                            this.getDataList();
                            clearTimeout(timer);
                        },500)
                        
                    }else{
                        this.$message.error(msg || '请求失败');
                        this.listLoading = false;
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                    this.listLoading = false;
                }).finally(() => {
                    // this.listLoading = false;
                });
            })
        },
        //编辑热度
        editHot(data){
            this.$refs.editHot.show(data);
        },

        review(data){
            this.$router.push({
                path: `/dynamic/article/review/${data.id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                },
            });
        },

        //置顶/取消置顶
        setTop(row){
            this.listLoading = true;
            this.$request({
                url: '/article/top',
                method: 'POST',
                params: {
                    articleId:row.id,
                    top:row.isTop == 1 ? 0 : 1
                }
            }).then(res => {
                const { state, msg } = res.data;
                if( state == 1 ){
                    let timer = setTimeout(() => {
                        this.getDataList();
                        clearTimeout(timer);
                    },800)
                    
                }else{
                    this.$message.error(msg || '操作失败');
                    this.listLoading = false;
                }
            }).catch(() => {
                this.$message.error('请求错误');
                this.listLoading = false;
            }).finally(() => {
                // this.listLoading = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.el-image{
    vertical-align: middle;
}
.video-cover{
    position: relative;
    cursor: pointer;
    &::after{
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        left: 0;
        top: 0;
    }
    span{
        font-size: 30px;
        position: absolute;
        left: 50%;
        margin-left: -15px;
        top: 50%;
        margin-top: -15px;
        color: #fff;
        z-index: 1;
    }
}
.preview-box{
    .video-cover{
        display: inline-block;
        margin: 10px;
    }
}
</style>